import React from 'react';
import { Target, TrendingUp, Shield } from 'lucide-react';
import useInView from '../hooks/useInView';
import './PhilosophySection.css';

const PhilosophySection = () => {
  const { ref, isInView } = useInView();

  const principles = [
    {
      icon: <Target size={32} />,
      title: 'Recover with purpose',
      description: 'Mithilfe von individualisierten Therapieplänen, die anhand Ihrer persönlichen Anforderungen erstellt werden, begleite ich Sie auf dem Weg zu Ihrem Ziel. Die Kombination aus aktiven und passiven Therapiemaßnahmen erlaubt es, die bestmögliche Funktion des Bewegungsapparats gezielt aufzubauen.'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Return with confidence',
      description: 'Der Weg zurück in Alltag, Training oder Wettkampf beginnt mit Vertrauen in Körper, Prozess und Therapie. Eine strukturierte, individuell abgestimmte und sportartspezifische Rehabilitation führt Ihren Körper Schritt für Schritt an die Anforderungen heran und bildet – gemeinsam mit evidenzbasierten Return-to-Activity-, Return-to-Sport- und Return-to-Competition-Kriterien – die Grundlage für einen verlässlichen, leistungsstarken und vertrauensvollen Wiedereinstieg.'
    },
    {
      icon: <Shield size={32} />,
      title: 'Prevent with knowledge',
      description: 'Mein Ziel ist es, nicht nur Verletzungen zu behandeln, sondern das Risiko für neue aktiv zu reduzieren. Verletzungsprävention ist daher ein zentraler Bestandteil Ihrer Therapie. Individuell abgestimmte Trainingsprogramme und gezielte Übungen bieten Ihnen einen nachhaltigen Weg, langfristig leistungsfähig, stabil und gesund zu bleiben – im Alltag, im Training und im Wettkampf.'
    }
  ];

  return (
    <section
      id="philosophie"
      className={`philosophy-section reveal-section ${isInView ? 'is-visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <div className="section-header reveal-item" style={{ '--reveal-delay': '0ms' }}>
          <h2 className="heading-2">Philosophie</h2>
          <p className="body-large section-subtitle">
            Mein Ansatz basiert auf drei grundlegenden Prinzipien
          </p>
        </div>
        <div className="philosophy-grid">
          {principles.map((principle, index) => (
            <div
              key={index}
              className="philosophy-card reveal-item"
              style={{ '--reveal-delay': `${120 + index * 100}ms` }}
            >
              <div className="card-icon">
                {principle.icon}
              </div>
              <h3 className="heading-3">{principle.title}</h3>
              <p className="body-medium">{principle.description}</p>
            </div>
          ))}
        </div>
        <div className="philosophy-quote reveal-item" style={{ '--reveal-delay': '420ms' }}>
          <blockquote>
            "It is time to come back stronger than you were before."
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
